import { useTranslation } from 'react-i18next'
import { DropdownItem, DropdownMenu, DropdownToggle, Input, UncontrolledDropdown } from 'reactstrap'

const DropDownWithCheckBox = ({ activityTypes, activityCriteria, handleCriteriaChange }) => {
    const { t } = useTranslation()

    const handleCheckBox = (e) => {
        e.stopPropagation()

        if (e.target.value === 'system') {
            const { source: _source, ...rest } = activityCriteria
            handleCriteriaChange(e.target.checked ? { ...rest, source: 'system' } : rest)
        } else {
            const currentActivityTypes = activityCriteria.activityType ?? []
            handleCriteriaChange({
                ...activityCriteria,
                activityType: e.target.checked
                    ? [...currentActivityTypes, e.target.value]
                    : currentActivityTypes.filter((type) => type !== e.target.value),
            })
        }
    }

    const isChecked = (value) => {
        return value === 'system' ? activityCriteria.source === 'system' : (activityCriteria.activityType ?? []).includes(value)
    }

    return (
        <UncontrolledDropdown className="ms-2" onClick={(e) => e.stopPropagation()}>
            <DropdownToggle tag="button" className="btn btn-light border border-2" id="dropdownMenuButton">
                {t('accordion.activities.dropdown.placeholder')} <i className="mdi mdi-chevron-down"></i>
            </DropdownToggle>
            <DropdownMenu id="dropDownMenu">
                {activityTypes.map((item, key) => (
                    <DropdownItem key={key} toggle={false}>
                        <Input
                            type="checkbox"
                            className="form-check-input"
                            id={`${item.label} ${item.value}`}
                            name={item.label}
                            value={item.value}
                            checked={isChecked(item.value)}
                            onChange={handleCheckBox}
                        />
                        <label className="ms-2">{item.label}</label>
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </UncontrolledDropdown>
    )
}

export default DropDownWithCheckBox
